import { gql } from 'graphql-tag';

export const CREATE_TOPIC = gql`
  mutation CreateLearningHubTopic($input: CreateLearningHubTopicInput!) {
    createLearningHubTopic(input: $input) {
      id
      name
      slug
      description
      mode
      icon
      sort_order
      is_active
      video_count
    }
  }
`;

export const UPDATE_TOPIC = gql`
  mutation UpdateLearningHubTopic($input: UpdateLearningHubTopicInput!) {
    updateLearningHubTopic(input: $input) {
      id
      name
      slug
      description
      mode
      icon
      sort_order
      is_active
      video_count
    }
  }
`;

export const DELETE_TOPIC = gql`
  mutation DeleteLearningHubTopic($id: Int!) {
    deleteLearningHubTopic(id: $id)
  }
`;

export const REORDER_TOPICS = gql`
  mutation ReorderLearningHubTopics($ids: [Int!]!, $mode: LearningHubMode!) {
    reorderLearningHubTopics(ids: $ids, mode: $mode) {
      id
      sort_order
    }
  }
`;

export const CREATE_VIDEO = gql`
  mutation CreateLearningHubVideo($input: CreateLearningHubVideoInput!) {
    createLearningHubVideo(input: $input) {
      id
      topic_id
      topic {
        id
        name
        slug
        icon
      }
      mode
      title
      description
      vimeo_id
      duration_label
      status
      is_new
      is_featured
      help_link
      sort_order
    }
  }
`;

export const UPDATE_VIDEO = gql`
  mutation UpdateLearningHubVideo($input: UpdateLearningHubVideoInput!) {
    updateLearningHubVideo(input: $input) {
      id
      topic_id
      topic {
        id
        name
        slug
        icon
      }
      mode
      title
      description
      vimeo_id
      duration_label
      status
      is_new
      is_featured
      help_link
      sort_order
    }
  }
`;

export const DELETE_VIDEO = gql`
  mutation DeleteLearningHubVideo($id: Int!) {
    deleteLearningHubVideo(id: $id)
  }
`;

export const REORDER_VIDEOS = gql`
  mutation ReorderLearningHubVideos($ids: [Int!]!, $topic_id: Int) {
    reorderLearningHubVideos(ids: $ids, topic_id: $topic_id) {
      id
      sort_order
    }
  }
`;

export const UPDATE_SETTINGS = gql`
  mutation UpdateLearningHubSettings($input: UpdateLearningHubSettingsInput!) {
    updateLearningHubSettings(input: $input) {
      id
      help_base_url
      show_new_badge_days
      max_featured_videos
    }
  }
`;
